import { render } from "./cis.cattle.io.clusterscan.vue?vue&type=template&id=20b1de79&scoped=true"
import script from "./cis.cattle.io.clusterscan.vue?vue&type=script&lang=js"
export * from "./cis.cattle.io.clusterscan.vue?vue&type=script&lang=js"

import "./cis.cattle.io.clusterscan.vue?vue&type=style&index=0&id=20b1de79&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b1de79"]])

export default __exports__